// NoAccess.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const NoAccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const message = location.state?.message || "You don't have permission to access this page.";

  return (
    <div className="container mt-5">
      <Alert variant="danger">
        <Alert.Heading>Access Denied</Alert.Heading>
        <p>{message} <Button 
                            variant="primary" 
                            onClick={() => navigate('/home')}
                            className="mt-2"
                          >
                            Return Home
                          </Button></p>
        {message.includes('fee payment') && (
          <Button variant="primary" onClick={() => navigate('/school-fee')}>
            View Fee Payment
          </Button>
        )}
      </Alert>
    </div>
  );
};

export default NoAccess;